import { normalize } from 'normalizr'

import api from '@functions/api'

import type { CampaignObjectiveModel } from '@models/types'

import { updateEntities } from '@redux/entities'

import type { Action, EntityOptions, Errors, FetchRequestPayload } from '@redux/modules/types'

import { Schemas } from '@redux/schema'

import type { AppDispatch } from '@redux/store'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/campaignObjective/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/campaignObjective/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/campaignObjective/FETCH_FAILURE'

export type CampaignObjectiveModuleState = {
  errors: string[],
  loaded: boolean,  
  loadedForKeys: string[],
  loadedIds: number[],
  loading: boolean,
}

// Initial State
const initialState: CampaignObjectiveModuleState = {
  errors: [],
  loaded: false,  
  loadedForKeys: [],
  loadedIds: [],
  loading: false,
}

// Actions
export function fetchRequest(payload: FetchRequestPayload = {}) {
  return {
    type: FETCH_REQUEST,
     loadedForKeys: payload.loadedForKeys,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess() {
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors: Errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadCampaignObjectives(options: EntityOptions = {}) {
  return (dispatch: AppDispatch) => {
    dispatch(fetchRequest())

    const promise = api('/references/campaign-objectives', options)
      .then(({ data }: { data: CampaignObjectiveModel[] }) => {
        const normalizedJson = normalize(data, Schemas.CAMPAIGN_OBJECTIVE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true as const, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false as const, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(
  state: CampaignObjectiveModuleState = initialState,
  action: Action = { type: '' },
): CampaignObjectiveModuleState {
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loadedForKeys: action.loadedForKeys || state.loadedForKeys,
        loadedIds: action.loadedIds || state.loadedIds,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors || [],
      }
    default:
      return state
  }
}
